import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import connect from '../../core/EcrionProvider/connect';
import currentSelector from '../selectors/grid';
import _changeMode from '../actions/grid/mode';
import Mode from './GridView/Mode';
import instances from './instances';
/**
 * @extends {React.Component<import('./types').DataGridModeSwitcherProps & { grid?: import('data/types').DataGridViewState<any> }> }
 */

var DataGridModeSwitcher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataGridModeSwitcher, _React$Component);

  function DataGridModeSwitcher() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataGridModeSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataGridModeSwitcher)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.changeMode = function (e, mode) {
      var gridProps = instances.all[_this.props.id].props;
      return _this.props.changeMode(e, _objectSpread({}, gridProps, {
        mode: mode
      }));
    };

    return _this;
  }

  _createClass(DataGridModeSwitcher, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          grid = _this$props.grid,
          rest = _objectWithoutProperties(_this$props, ["grid"]);

      return React.createElement(Mode, Object.assign({
        mode: grid.view.mode,
        onChange: this.changeMode
      }, rest));
    }
  }]);

  return DataGridModeSwitcher;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    grid: currentSelector(state, ownProps)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeMode: function changeMode(e, props) {
      return dispatch(_changeMode(props));
    }
  };
};

DataGridModeSwitcher.defaultProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DataGridModeSwitcher);